// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const Intl = require('intl');
Intl.__addLocaleData(require('intl-locale-data'));
